import {createFeatureSelector, createSelector} from "@ngrx/store";
import {planetFeatureKey} from "./planet-list.reducer";
import {Planet} from "../../models/Planet";


export const planetListSelector = createFeatureSelector<Planet[]>(planetFeatureKey);
